import { IAddToPoProduct } from '@/models/add_to_po';

export function buyingTableRowToAddToPoProduct(row: any): IAddToPoProduct {
  // Buying-table rows carry supplier info on two flat fields:
  //   supplier_id: string ('unknown' when the row has no linked supplier)
  //   supplier:    string (display name)
  // (see BuyingTable.vue:1821-1822 and :2557-2561)
  const rawSupplierId = row?.supplier_id;
  const isUnknownSupplier =
    !rawSupplierId || rawSupplierId === 'unknown' || rawSupplierId === '-';
  const parsedSupplierId = isUnknownSupplier ? null : Number(rawSupplierId);
  const supplierId = Number.isFinite(parsedSupplierId as number) ? parsedSupplierId : null;

  // Guard against missing/non-numeric variant_id. Callers should always
  // provide one, but NaN propagates silently into dedupe filters and the
  // POST payload, which is worse than an obviously-bogus 0 we can detect.
  const parsedVariantId = Number(row?.variant_id ?? row?.variantId);
  const variantId = Number.isFinite(parsedVariantId) ? parsedVariantId : 0;

  return {
    variantId,
    supplierId,
    supplierName: supplierId == null ? null : (row.supplier || null),
    productName: row.productName || row['Item[Item Description]'] || 'Unknown Product',
    variant: row.variant || '',
    sku: row.sku || row.product_sku || '',
    supplierSku: row.supplier_sku || row.supplierSku || '',
    variantImage: row.variant_image,
    suggestedQuantity: Number(row.reorderQuantity || row['[inventory_replenishment]'] || 1),
    // US-CURR-013: `row.unitCost` is the OLAP `[average_unit_cost]` — a STORE-currency
    // Shopify cost. Tag it so the drawer re-resolves it against the chosen PO's
    // supplier currency instead of stamping a USD amount onto a EUR PO.
    suggestedUnitPrice: Number(row.unitCost) || 0,
    costSourceCurrency: 'store',
    source: 'buying_table',
  };
}
